import { Component, OnInit } from '@angular/core';
import { Notification } from '../../admin/admin.interface';
import { NotificationService } from './notification.service';
import { SessionStorage } from 'ngx-webstorage';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;

  public notification: Notification[] = [];
  public pageNumber: number = 1;
  public totalElements: any = 0;
  constructor(private notificationService: NotificationService,
    private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.getNotificationList();
  }

  /**Function to list notification*/
  getNotificationList() {
    this.notification = [];
    this.spinnerService.show();
    this.notificationService.getNotification(this.pageNumber).subscribe((data) => {
    this.spinnerService.hide();
      if (data.payload.notifications) {
        this.totalElements = data.payload.totalnotifications;
        data.payload.notifications.map(value => this.notification.push(new Notification(value)));
      }
    },
    (error) => {
      this.spinnerService.hide();
    });
  }

  /**Function to get notification when paginate */
  triggerChange(data: any) {
    this.pageNumber = data;
    this.getNotificationList();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/notification/notification.component.ts